import React from 'react'
import { Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import { ROUTER } from './../../class/constants'

import { useLocation } from 'react-router-dom'

const ScreenAuth = ({ isAuth, children }) => {
  const location = useLocation()

  if (!isAuth)
    return <Redirect to={{ pathname: ROUTER.LOGIN, state: {
      redirectTo: location.pathname
    }
    }} />

  return children
}

const mapStateToProps = state => ({
  isAuth: state.ReducerAuth.isAuth,
})

export default connect(mapStateToProps)(ScreenAuth)